import React from "react";
import AdminMenuItem from "./AdminMenuItem";
import pages from "../content/pages";
import SettingsIcon from '@mui/icons-material/Settings';
function SettingsItem() {
    return <AdminMenuItem name={pages.SETTINGS} icon={<SettingsIcon />} text="adminMenu.settings" />
}
export default SettingsItem